import React from "react";

import { AboutUsIntro } from "./aboutUsIntro";
import { AboutUsTeam } from "./aboutUSTeam";
import { ImpactVideos } from "./impactVideos";
import DownloadPack from "../teen-volunteering-page/downloadPack";

const AboutUsPageComponent = ({ page }) => {
  const genericDetails = page.acfLandingPage;

  const genPpackSectionTitle = genericDetails?.genPpackSectionTitle ?? "";
  const genPpackTitle = genericDetails?.genPpackTitle ?? "";
  const genPpackSummary = genericDetails?.genPpackSummary ?? "";
  const genPpackCtaLink = genericDetails?.genPpackCtaLink ?? "";
  const genPpackImage =
    genericDetails?.genPpackImage?.localFile ??
    genericDetails?.genPpackImage?.sourceUrl ??
    [];
  const gen20YearsOfSustainableImpactTitle =
    genericDetails?.gen20YearsOfSustainableImpactTitle ?? "";
  const firstFeatVid =
    genericDetails?.genAboutUs20YearsOfSustainableImpact[0]
      ?.genSustainableImpactVideoUrl ?? "";

  const secondFeatVid =
    genericDetails?.genAboutUs20YearsOfSustainableImpact[1]
      ?.genSustainableImpactVideoUrl ?? "";

  const thirdFeatVid =
    genericDetails?.genAboutUs20YearsOfSustainableImpact[2]
      ?.genSustainableImpactVideoUrl ?? "";

  const teamMembers = genericDetails?.genAboutUsMeetTheTeam;
  const aboutTeamTitle = genericDetails?.genAboutUsTeamTitle ?? "Meet the team";
  const genAboutUsTeamSubtitle = genericDetails?.genAboutUsTeamSubtitle ?? "";
  const genAboutUsTeamContent = genericDetails?.genAboutUsTeamContent ?? "";
  const featuredImage = genericDetails.genAboutUsTeamIcon?.node.localFile;
  const sourceFallbackImage = genericDetails.genAboutUsTeamIcon?.node.sourceUrl;

  return (
    <>
      <AboutUsIntro pageTitle={page?.title} aboutIntroContent={page.content} />
      {firstFeatVid && secondFeatVid && thirdFeatVid && (
        <ImpactVideos
          gen20YearsOfSustainableImpactTitle={
            gen20YearsOfSustainableImpactTitle
          }
          firstVid={firstFeatVid}
          secondVid={secondFeatVid}
          thirdVid={thirdFeatVid}
        />
      )}
      {teamMembers && (
        <AboutUsTeam
          genAboutUsTeamTitle={aboutTeamTitle}
          genAboutUsTeamSubtitle={genAboutUsTeamSubtitle}
          genAboutUsTeamContent={genAboutUsTeamContent}
          bgImage={featuredImage}
          sourceUrl={sourceFallbackImage}
          teamMembers={teamMembers}
        />
      )}

      {genPpackTitle && genPpackSummary && genPpackCtaLink ? (
        <DownloadPack
          packTitle={genPpackSectionTitle}
          infoPackLabel={genPpackTitle}
          infoPackText={genPpackSummary}
          bgImage={genPpackImage}
          infoPackFile={genPpackCtaLink}
          containerClassNames="!bg-yellow-lighter planet:!bg-gray-darker"
          viewmoreLink=""
        />
      ) : (
        <div className="py-10 w-full bg-yellow-lighter planet:bg-gray-darker spacer" />
      )}
    </>
  );
};

export default AboutUsPageComponent;
